"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _toConsumableArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.manageStickyAttributes = exports.isStickyMode = exports.getKeywordSessionItem = exports.getSearchKeywordsConfig = exports.getUrl = exports.wrapOptionDisplay = exports.setStyleOfElement = exports.removeClassOfRef = exports.applyClassToRef = exports.renderColFooterLink = exports.getGlobalMenuLeftOffset = exports.getGlobalMenuWidth = exports.getMenuWidth = exports.mergeColumnsWithItems = exports.prepGlobalMenuData = exports.columnId = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var react_1 = require("@emotion/react");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var StyledComponents_1 = require("../../Renderers/StyledComponents");

var frontend_common_1 = require("@ryerson/frontend.common");

var Constants_1 = require("../../common/Constants");

var columnId;

(function (columnId) {
  columnId["REFERENCES_ID"] = "references";
  columnId["TOOLS_CALC_ID"] = "tools-calculations";
  columnId["TUTORIALS_ID"] = "tutorials";
  columnId["CUSTOMIZED_SOLUTIONS_ID"] = "customized-solutions";
  columnId["MARKET_INTEL_ID"] = "metal-market-intelligence";
  columnId["SUCCESS_STORIES_ID"] = "success-stories";
  columnId["SOlUTIONS_ID"] = "solutions";
})(columnId || (exports.columnId = columnId = {})); // Slice and Dice data for Global Menu Header Display


var prepGlobalMenuData = function prepGlobalMenuData(headerData) {
  var _a, _b;

  var _ref = headerData || {},
      _ref$globalMenus = _ref.globalMenus,
      globalMenus = _ref$globalMenus === void 0 ? [] : _ref$globalMenus; // Get Source Menu (top level menu)


  var metalResources = globalMenus.find(function (menu) {
    return menu.name === "metalResources";
  });
  var whyRyerson = globalMenus.find(function (menu) {
    return menu.name === "whyRyerson";
  }); // Get target column (to merge into its items array)

  var references = (_a = metalResources === null || metalResources === void 0 ? void 0 : metalResources.items) === null || _a === void 0 ? void 0 : _a.find(function (menu) {
    return menu.id === columnId.REFERENCES_ID;
  });
  var customizedSolutions = (_b = whyRyerson === null || whyRyerson === void 0 ? void 0 : whyRyerson.items) === null || _b === void 0 ? void 0 : _b.find(function (menu) {
    return menu.id === columnId.CUSTOMIZED_SOLUTIONS_ID;
  }); // Array Of Column Ids to Find and add

  var metalResoucresIds = [columnId.TOOLS_CALC_ID, columnId.TUTORIALS_ID];
  var whyRyersonIds = [columnId.SUCCESS_STORIES_ID]; // Get New Items Arrays that has items merged in

  var referencesMenuItems = (0, exports.mergeColumnsWithItems)(metalResoucresIds, metalResources === null || metalResources === void 0 ? void 0 : metalResources.items, references === null || references === void 0 ? void 0 : references.items);
  var customizedSolutionsItems = (0, exports.mergeColumnsWithItems)(whyRyersonIds, whyRyerson === null || whyRyerson === void 0 ? void 0 : whyRyerson.items, customizedSolutions === null || customizedSolutions === void 0 ? void 0 : customizedSolutions.items); // Modify a Copy of The Menu Data

  var modifiedGlobalMenus = _toConsumableArray(globalMenus);

  modifiedGlobalMenus.forEach(function (menu) {
    if (menu.name === "metalResources" && referencesMenuItems) {
      menu.items = removeItemsWithId(menu.items, metalResoucresIds);
      setNewItems(menu.items, columnId.REFERENCES_ID, referencesMenuItems);
    } else if (menu.name === "whyRyerson" && customizedSolutionsItems) {
      menu.items = removeItemsWithId(menu.items, whyRyersonIds);
      setNewItems(menu.items, columnId.CUSTOMIZED_SOLUTIONS_ID, customizedSolutionsItems);
    }
  });
  return modifiedGlobalMenus;
};

exports.prepGlobalMenuData = prepGlobalMenuData; // Merge External Columns  from source menu  into the items arrays target menu

var mergeColumnsWithItems = function mergeColumnsWithItems(itemIDArray, sourceItemsArray, targetItemsArray) {
  var recordIndexes = [];
  sourceItemsArray === null || sourceItemsArray === void 0 ? void 0 : sourceItemsArray.forEach(function (col, idx) {
    itemIDArray.includes(col.id) && recordIndexes.push(idx);
  });
  recordIndexes.forEach(function (itemIndex) {
    var extractedItems = (sourceItemsArray === null || sourceItemsArray === void 0 ? void 0 : sourceItemsArray.slice(itemIndex, itemIndex + 1)) || [];
    targetItemsArray = [].concat(_toConsumableArray(targetItemsArray), _toConsumableArray(extractedItems));
  });
  return targetItemsArray;
};

exports.mergeColumnsWithItems = mergeColumnsWithItems;

var removeItemsWithId = function removeItemsWithId(itemsArray, itemIdsArray) {
  return itemsArray.filter(function (col) {
    return !itemIdsArray.includes(col.id);
  });
};

var setNewItems = function setNewItems(itemsArray, targetMenuId, newItemsArray) {
  return itemsArray.forEach(function (menuItem) {
    menuItem.id && menuItem.id === targetMenuId && (menuItem.items = newItemsArray);
  });
}; // Helper for Location Menu


var getMenuWidth = function getMenuWidth(country, language) {
  switch (true) {
    case country === frontend_application_1.Country.us && (language === frontend_application_1.Language.fr || language === frontend_application_1.Language.es):
      return 620;

    case country === frontend_application_1.Country.us || country === frontend_application_1.Country.cn:
      return 600;

    case country === frontend_application_1.Country.ca && (language === frontend_application_1.Language.en || language === frontend_application_1.Language.es):
      return 180;

    case country === frontend_application_1.Country.ca:
      return 220;

    default:
      return 144;
  }
};

exports.getMenuWidth = getMenuWidth; // Global Menus Width Configuration

var getGlobalMenuWidth = function getGlobalMenuWidth(menuName, _ref2, mobileBreakPoint) {
  var _ref3 = _slicedToArray(_ref2, 1),
      width = _ref3[0];

  switch (menuName) {
    case "metalSolutions":
      return width >= mobileBreakPoint ? 800 : 620;

    case "whyRyerson":
      return width >= mobileBreakPoint ? 500 : 420;

    case "metalResources":
      return width >= mobileBreakPoint ? 500 : 360;

    default:
      return 160;
  }
};

exports.getGlobalMenuWidth = getGlobalMenuWidth; // Global Menus LeftOffset Configuration - to ensure menu offscreen

var getGlobalMenuLeftOffset = function getGlobalMenuLeftOffset(menuName, _ref4, mobileBreakPoint) {
  var _ref5 = _slicedToArray(_ref4, 1),
      width = _ref5[0];

  switch (menuName) {
    case "metalSolutions":
      return width >= mobileBreakPoint ? -30 : 0;

    case "whyRyerson":
      return width >= mobileBreakPoint ? -120 : -140;

    case "metalResources":
      return width >= mobileBreakPoint ? 0 : 0;

    default:
      return 0;
  }
};

exports.getGlobalMenuLeftOffset = getGlobalMenuLeftOffset;

var renderColFooterLink = function renderColFooterLink(theme, breakPoint, displayText, justify, _onClick, menuAcive, topOffset) {
  var _theme$colors = theme.colors,
      secondaryBrand = _theme$colors.primary.secondaryBrand,
      blue = _theme$colors.secondary.blue;
  return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
    direction: "column",
    justifyContent: justify,
    css: (0, react_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\theight: 100%;\n\t\t\t"]))),
    children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
      weight: "bold",
      breakPoint: breakPoint,
      css: (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\t\t", "\n\n\t\t\t\t\t", "\n\t\t\t\t"])), (0, StyledComponents_1.colFooterLinks)(blue), topOffset && "top:".concat(topOffset, "px")),
      color: secondaryBrand,
      variant: "div",
      children: (0, jsx_runtime_1.jsx)("span", {
        css: {
          whiteSpace: "pre-line"
        },
        onClick: function onClick() {
          return _onClick();
        },
        children: displayText
      })
    })
  });
};

exports.renderColFooterLink = renderColFooterLink; // Utility To apply a className to a ref Dom element

var applyClassToRef = function applyClassToRef(domNodeRefs, elementRefName, className) {
  var _a, _b, _c;

  var el = (_a = domNodeRefs[elementRefName]) === null || _a === void 0 ? void 0 : _a.current;
  !((_b = el === null || el === void 0 ? void 0 : el.classList) === null || _b === void 0 ? void 0 : _b.contains(className)) && ((_c = el === null || el === void 0 ? void 0 : el.classList) === null || _c === void 0 ? void 0 : _c.add(className));
};

exports.applyClassToRef = applyClassToRef; // Utility To remove a className to a ref Dom element

var removeClassOfRef = function removeClassOfRef(domNodeRefs, elementRefName, className) {
  var _a, _b;

  var el = (_a = domNodeRefs[elementRefName]) === null || _a === void 0 ? void 0 : _a.current;
  (_b = el === null || el === void 0 ? void 0 : el.classList) === null || _b === void 0 ? void 0 : _b.remove(className);
};

exports.removeClassOfRef = removeClassOfRef; // Utility style attribute to Dom element

var setStyleOfElement = function setStyleOfElement(el, styleString) {
  var style = el.getAttribute("style");
  style !== styleString && el && el.setAttribute("style", styleString);
};

exports.setStyleOfElement = setStyleOfElement; // For special case in displaying "China" option / country menu

var wrapOptionDisplay = function wrapOptionDisplay(country, displayItem, color) {
  return country === "".concat(frontend_application_1.Country.cn) ? (0, jsx_runtime_1.jsxs)("span", {
    children: [displayItem, " ", (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
      color: color,
      circled: true,
      icon: "arrow-up-right",
      size: "sm-md"
    })]
  }) : displayItem;
};

exports.wrapOptionDisplay = wrapOptionDisplay; // Utility to get the full URL

var getUrl = function getUrl(url) {
  var externalUrl = url;

  if (typeof window !== "undefined") {
    externalUrl = window.location.origin + url;
  }

  return externalUrl;
};

exports.getUrl = getUrl;

var getOrdersDashboardUrl = function getOrdersDashboardUrl() {
  var storeDirectory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constants_1.STORE;
  return "".concat(storeDirectory, "/dashboard/orders");
};

var getQuotesDashboardUrl = function getQuotesDashboardUrl() {
  var storeDirectory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constants_1.STORE;
  return "".concat(storeDirectory, "/dashboard/quotes");
};

var getSearchKeywordsConfig = function getSearchKeywordsConfig() {
  var storeDirectory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constants_1.STORE;
  var ordersDashboardUrl = getOrdersDashboardUrl(storeDirectory);
  var quotesDashboarddUrl = getQuotesDashboardUrl(storeDirectory);
  var quoteKeywordsConfig = {
    en: [{
      title: "Quotes Dashboard",
      to: quotesDashboarddUrl,
      disabled: false
    }],
    es: [{
      title: "Panel de cotizaciones",
      to: quotesDashboarddUrl,
      disabled: false
    }],
    fr: [{
      title: "Tableau de bord des devis",
      to: quotesDashboarddUrl,
      disabled: false
    }]
  };
  var orderKeywordsConfig = {
    en: [{
      title: "All Orders",
      to: ordersDashboardUrl,
      disabled: false
    }, {
      title: "Open Orders",
      to: ordersDashboardUrl,
      disabled: true
    }],
    es: [{
      title: "Todas las órdenes",
      to: ordersDashboardUrl,
      disabled: false
    }, {
      title: "Ordenes abiertas",
      to: ordersDashboardUrl,
      disabled: true
    }],
    fr: [{
      title: "Tous les ordres",
      to: ordersDashboardUrl,
      disabled: false
    }, {
      title: "Commandes ouvertes",
      to: ordersDashboardUrl,
      disabled: true
    }]
  };
  return {
    en: {
      quote: quoteKeywordsConfig.en,
      quotes: quoteKeywordsConfig.en,
      order: orderKeywordsConfig.en,
      orders: orderKeywordsConfig.en
    },
    es: {
      cita: quoteKeywordsConfig.es,
      citas: quoteKeywordsConfig.es,
      pedido: orderKeywordsConfig.es,
      pedidos: orderKeywordsConfig.es
    },
    fr: {
      citation: quoteKeywordsConfig.fr,
      devis: quoteKeywordsConfig.fr,
      ordre: orderKeywordsConfig.fr,
      ordres: orderKeywordsConfig.fr
    }
  };
};

exports.getSearchKeywordsConfig = getSearchKeywordsConfig;

var getKeywordSessionItem = function getKeywordSessionItem(keyword) {
  var storeDirectory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Constants_1.STORE;
  var keywordSessionMap = [{
    keywords: ["quote", "quotes", "cita", "citas", "citation", "devis"],
    sessionItem: frontend_common_1.SessionItems.searchQuote,
    dashboardUrl: getQuotesDashboardUrl(storeDirectory)
  }, {
    keywords: ["order", "orders", "pedido", "pedidos", "ordre", "ordres"],
    sessionItem: frontend_common_1.SessionItems.searchOrder,
    dashboardUrl: getOrdersDashboardUrl(storeDirectory)
  }];
  var config = keywordSessionMap.find(function (_ref6) {
    var keywords = _ref6.keywords;
    return keywords.includes(keyword);
  });
  return config ? {
    sessionItem: config.sessionItem,
    dashboardUrl: config.dashboardUrl
  } : {};
};

exports.getKeywordSessionItem = getKeywordSessionItem;
/**
 * Determine if the header should be STICKY or not
 * @param windowSize -output from useWindowSize hook
 * @param windowScroll 	-	output from useWindowScroll hook
 * @param scrollMax -- max scroll value to trigger sticky
 * @returns boolean
 */

var isStickyMode = function isStickyMode(windowSize, windowScroll, scrollMax, breakPoint) {
  // Sticky Header Constants:
  // const scrollMax = 50;
  var widthMax = breakPoint,
      heightMax = 500;

  var _windowSize = _slicedToArray(windowSize, 2),
      currentWidth = _windowSize[0],
      currentHeight = _windowSize[1]; //  Sticky Header Padding:
  //  Content is the main body content of the sibling container that gets padding when sticky
  //const stickyPaddingStyle = `padding-top:calc(${scrollMax}px * 2 + 60px + 4px)`;
  // isSticky : Three  Values determines if to apply sticky menu


  var heightThreshold = currentHeight > heightMax;
  var widthThreshold = currentWidth >= widthMax;
  var scrollThreshold = windowScroll >= scrollMax;
  return heightThreshold && widthThreshold && scrollThreshold || false;
};

exports.isStickyMode = isStickyMode;

var manageStickyAttributes = function manageStickyAttributes(isSticky, contentElementStyle, windowScroll, scrollMax, domNodeRefs, callBackOnSticky) {
  // Manage Sticky Classes Applied to Items
  if (isSticky.current) {
    (0, exports.applyClassToRef)(domNodeRefs, "globalNavigation", "sticky");
    (0, exports.applyClassToRef)(domNodeRefs, "productNavigation", "sticky");
  } else {
    (0, exports.removeClassOfRef)(domNodeRefs, "globalNavigation", "sticky");
    (0, exports.removeClassOfRef)(domNodeRefs, "productNavigation", "sticky");
  } // Upon any scrolling ensure all menus closed


  if (windowScroll) {
    callBackOnSticky();
  } // Manage Padding on Content Area, inserted during Sticky Mode
  // Note: This assumes header is in fresnel parent container


  var contentEl = typeof document !== "undefined" && (document === null || document === void 0 ? void 0 : document.querySelector("#root"));

  if (isSticky.current && contentEl) {
    //  Content is the main body content of the sibling container that gets padding when sticky
    var stickyPaddingStyle = "padding-top:calc(".concat(scrollMax, "px * 2 + 60px + 4px)");
    (0, exports.setStyleOfElement)(contentEl, stickyPaddingStyle);
  } else {
    contentEl && (0, exports.setStyleOfElement)(contentEl, contentElementStyle.current);
  }
};

exports.manageStickyAttributes = manageStickyAttributes;